module.exports = __webpack_public_path__ + "img/branch_moorea.1eb8f463.png";